import { SocketMessage, SocketMessageEvent } from '../sockets/messages';
import { UploadId } from '../upload';
import { IPartialAuditDataController } from './audit';
import { JobFailure } from './job-failure';

export interface IPublishEmailRequest<CD> {
    channelData: CD;
    uploadId: UploadId;
    auditData: IPartialAuditDataController;
}

export interface IPublishEmailResponseLegacy {
    executionId: string;
}

export interface IPublishEmailResponse {
    scheduledEmailItemId: string;
}

export interface EmailProcessingFinishedMessage
    extends SocketMessage<IPublishEmailResponse | IPublishEmailResponseLegacy> {
    name: 'emailProcessJobFinished';
}
export const EmailProcessingFinishedEvent = new SocketMessageEvent<IPublishEmailResponseLegacy>(
    'emailProcessJobFinished',
);

export interface EmailProcessingFailedMessage extends SocketMessage<JobFailure> {
    name: 'emailProcessJobFailed';
}
export const EmailProcessingFailedEvent = new SocketMessageEvent<JobFailure>('emailProcessJobFailed');
